export const askYogiLoadingMessages = [
  'Yogi is thinking',
  "Reading through your customers' feedback…",
  'Narrowing down the feedback…',
  'Cross-referencing themes and products…',
  'Framing the analysis…',
]
